import WGLLog from './logger';

const createElementArrayBuffer = (gl, raw) => {
  const id = gl.createBuffer();
  gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, id);
  gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, raw, gl.STATIC_DRAW);
  return id;
};

const createVertexAttribBuffer = (gl, raw) => {
  const id = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, id);
  gl.bufferData(gl.ARRAY_BUFFER, raw, gl.DYNAMIC_DRAW);
  return id;
};

// implements 'drawable', i.e., has 'prepareVertexAttrib', 'draw'
class WGLDrawable {
  constructor(key) {
    this.key = key;
  }

  // eltArray: Uint16Array
  // vertexAttribDefs: array of { name, size, [Float32Array] data }
  setGeometry(gl, eltArray, vertexAttribDefs) {
    const bufElt = createElementArrayBuffer(gl, eltArray);

    const vertexAttribs = {};
    for (let i = 0; i < vertexAttribDefs.length; i++) {
      const vaDef = vertexAttribDefs[i];
      vertexAttribs[vaDef.name] = {
        size: vaDef.size,
        data: vaDef.data,
        buf: createVertexAttribBuffer(gl, vaDef.data),
      };
    }

    // save properties
    this.elementCount = eltArray.length;
    this.bufElt = bufElt;
    this.vertexAttribs = vertexAttribs;

    this._log('Created');
  }

  _log(msg) {
    WGLLog.info('Drawable', this.key, msg);
  }

  updateVertexAttrib(gl, name) {
    const { vertexAttribs } = this;

    const vaData = vertexAttribs[name];
    if (!vaData) {
      this._log('WARNING UNDEFINED');
      return;
    }
    gl.bindBuffer(gl.ARRAY_BUFFER, vaData.buf);
    gl.bufferSubData(gl.ARRAY_BUFFER, 0, vaData.data);
  }

  prepareVertexAttrib(gl, name, index) {
    const { vertexAttribs } = this;

    const vaData = vertexAttribs[name];
    if (!vaData) {
      this._log('WARNING UNDEFINED');
      return;
    }
    gl.bindBuffer(gl.ARRAY_BUFFER, vaData.buf);
    gl.vertexAttribPointer(index, vaData.size, gl.FLOAT, false, 0, 0);
  }

  draw(gl) {
    const { bufElt, elementCount } = this;

    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, bufElt);
    gl.drawElements(gl.TRIANGLES, elementCount, gl.UNSIGNED_SHORT, 0);
  }

  free(gl) {
    const { bufElt, vertexAttribs } = this;

    gl.deleteBuffer(bufElt);
    Object.values(vertexAttribs).forEach((va) => {
      gl.deleteBuffer(va.buf);
    });

    this._log('Deleted');
  }
}

export default WGLDrawable;
